export default "__VITE_ASSET__BERQ1YBA__"